import React from 'react';

export const Posts = ({ size = 18, ...rest }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="#FEB45F" strokeWidth="1.5" fill="none" />
            <rect x="6" y="7" width="5" height="5" rx="0.5" fill="#FEB45F" />
            <line x1="13" y1="8" x2="18" y2="8" stroke="#FEB45F" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="13" y1="11" x2="18" y2="11" stroke="#FEB45F" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="6" y1="15" x2="18" y2="15" stroke="#FEB45F" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="6" y1="18" x2="14" y2="18" stroke="#FEB45F" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};
